import * as swcHelpers from '@swc/helpers';
import * as React from 'react';

const GoogleMapsContextDefaultValues = {
    googleMapsSettings: {
        apiKey: '',
        defaultCenter: {
            lat: 0,
            lng: 0
        },
        defaultZoom: 0
    }
};
const GoogleMapsContext = /*#__PURE__*/ React.createContext(GoogleMapsContextDefaultValues);
const useGoogleMapsContext = ()=>React.useContext(GoogleMapsContext)
;
function GoogleMapsProvider({ settings , children  }) {
    return /*#__PURE__*/ React.createElement(GoogleMapsContext.Provider, {
        value: {
            googleMapsSettings: swcHelpers.objectSpread({}, settings, {
                defaultZoom: settings.defaultZoom,
                hasCustomZoomLevel: settings.hasCustomZoomLevel
            })
        }
    }, children);
}
function withGoogleMaps(Component) {
    const wrappedName = Component.displayName || Component.name || 'Component';
    const WithGoogleMaps = (props)=>/*#__PURE__*/ React.createElement(GoogleMapsContext.Consumer, null, (context)=>/*#__PURE__*/ React.createElement(Component, swcHelpers.extends({}, props, {
                settings: context
            }))
        )
    ;
    WithGoogleMaps.displayName = `WithGoogleMaps(${wrappedName})`;
    return WithGoogleMaps;
}

export { GoogleMapsContextDefaultValues, GoogleMapsProvider, GoogleMapsContext as default, useGoogleMapsContext, withGoogleMaps };
//# sourceMappingURL=GoogleMapsContext.js.map
